import React from 'react';
import { useSelector } from 'react-redux';
import { Dialog, Box, Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SmartSendPreview from './SmartSendPreview';

// The e-mail preview dialog, shared by the mapping screen and the send summary's e-mail card.
// (Not "EmailPreviewDialog": SendSearch already has one.) dir is explicit — dialogs portal outside App's <div dir>.

interface Props {
    open: boolean;
    /** A CampaignID of dbo.Campaigns. */
    campaignId: number;
    onClose: () => void;
}

const SmartSendPreviewDialog: React.FC<Props> = ({ open, campaignId, onClose }) => {
    const { t } = useTranslation();
    const isRTL = useSelector((s: any) => s.core && s.core.isRTL);
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            dir={isRTL ? 'rtl' : 'ltr'}
            PaperProps={{ style: { height: '90vh' } }}
        >
            <Box style={{ flex: '0 0 auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 24px', borderBottom: '1px solid #e0e0e0' }}>
                <Typography variant="h6">{t('DataSources.send.preview')}</Typography>
            </Box>
            <Box style={{ flex: '1 1 auto', minHeight: 0, padding: 12 }}>
                <SmartSendPreview campaignId={campaignId} height="100%" />
            </Box>
            <Box style={{ flex: '0 0 auto', display: 'flex', justifyContent: 'flex-end', gap: 12, padding: '16px 24px', borderTop: '1px solid #e0e0e0' }}>
                {/* "סגור", not "ביטול" — in the summary "ביטול" abandons the send. */}
                <Button onClick={onClose}>{t('DataSources.send.close')}</Button>
            </Box>
        </Dialog>
    );
};

export default SmartSendPreviewDialog;
